/** Breadcrumb dyanmic key that will be replaced with its value on resolving the route */
export enum BreadcrumbToken {
  ModuleName = '$$MODULE_NAME$$',
  EntityName = '$$ENTITY_NAME$$',
  CollectionName = '$$COLLECTION_NAME$$',
  ViewName = '$$VIEW_NAME$$',
  GenericViewName = '$$GENERIC_VIEW_NAME$$',
  ReportName = '$$REPORT_NAME$$',
  StatisticName = '$$STATISTIC_NAME$$',
  ServiceName = '$$SERVICE_NAME$$',
  RelationName = '$$RelationName$$',
  EntryTitle = '$$Entry_TITLE$$',
  ViewEntry = '$$VIEW_ENTRY$$',
  EditEntry = '$$EDIT_ENTRY$$',
  EntryForm = '$$ENTRY_FORM$$',
  RequestTitle = '$$REQUEST_TITLE$$',
}
